"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const icons_vue_1 = require("@ant-design/icons-vue");
const complex_utils_1 = require("complex-utils");
const SiderMenu_1 = __importDefault(require("./SiderMenu"));
const menu_1 = __importDefault(require("../../data/menu"));
const router_1 = __importDefault(require("../../router"));
const plugin_1 = require("@/plugin");
exports.default = (0, vue_1.defineComponent)({
    components: {
        MenuUnfoldOutlined: icons_vue_1.MenuUnfoldOutlined,
        MenuFoldOutlined: icons_vue_1.MenuFoldOutlined,
        SiderMenu: SiderMenu_1.default
    },
    data() {
        return {
            menu: menu_1.default
        };
    },
    computed: {
        menuList() {
            const list = menu_1.default.menu;
            return list;
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(val) {
                this.menu.setCurrent(val);
            }
        }
    },
    methods: {
        toggleCollapsed() {
            this.menu.collapsed = !this.menu.collapsed;
            plugin_1.reactiveLayout.triggerChange('sider');
        },
        onSelect(type, key) {
            if (type === 'menu') {
                if (key !== this.menu.current[0]) {
                    router_1.default.push(key);
                }
            }
            else {
                (0, complex_utils_1.openWindow)(key);
            }
        }
    }
});
